import { render } from "./transferencias-editar.vue?vue&type=template&id=59885c54"
import script from "./transferencias-editar.vue?vue&type=script&lang=js"
export * from "./transferencias-editar.vue?vue&type=script&lang=js"

import "./transferencias-editar.vue?vue&type=style&index=0&id=59885c54&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__